import { RiAlignItemBottomFill } from "react-icons/ri";
import "./CardStack.scss";

const CardStack = ({dataList}) => {
  return (
    <section className="card_stack p_bottom">
      <div className="content_wrap">
        <div className="info_grid">
          <div className="title_side">
            <h2 className="wow fadeInUp">Solutions Offered</h2>
          </div>
          <div className="info_side">

            {
               dataList?.map((item) => {
                  return(
                    <div className="info_card wow fadeInUp" key={item?._id}>
                    <h4>{item?.title}</h4>
                    <p>
                      {item?.content}
                    </p>
                  </div>
                  )
              })
            }
           
          </div>
        </div>
      </div>
    </section>
  );
};

export default CardStack;
